import { render, staticRenderFns } from "./dashboard.vue?vue&type=template&id=6bb950c1&scoped=true&"
import script from "./dashboard.vue?vue&type=script&lang=ts&"
export * from "./dashboard.vue?vue&type=script&lang=ts&"
import style0 from "./dashboard.vue?vue&type=style&index=0&lang=less&"
import style1 from "./dashboard.vue?vue&type=style&index=1&id=6bb950c1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb950c1",
  null
  
)

export default component.exports